<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="descriptionOfWork">Description of Work</label>
                    <input
                        type="text"
                        class="form-control"
                        id="descriptionOfWork"
                        [(ngModel)]="target.descriptionOfWork"
                        name="descriptionOfWork"
                    />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="materialType">Material Type</label>
                    <input type="text" class="form-control" id="materialType" [(ngModel)]="target.materialType" name="materialType" />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="vendor">Vendor</label>
                    <wj-combo-box
                        id="vendor"
                        [(ngModel)]="target.vendor"
                        name="vendor"
                        [itemsSource]="vendorOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isEditable]="false"
                        style="width: 100%"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="product">Product</label>
                    <input type="text" class="form-control" id="product" [(ngModel)]="target.product" name="product" />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="minimumLift">Minimum Lift</label>
                    <input type="text" class="form-control" id="minimumLift" [(ngModel)]="target.minimumLift" name="minimumLift" />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="requiredDepth">Required Depth</label>
                    <input type="text" class="form-control" id="requiredDepth" [(ngModel)]="target.requiredDepth" name="requiredDepth" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="minimumTest">Min. Test Frequency</label>
                    <input type="text" class="form-control" id="minimumTest" [(ngModel)]="target.minimumTest" name="minimumTest" />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="requiredCompaction">Required Compaction</label>
                    <input
                        type="text"
                        class="form-control"
                        id="requiredCompaction"
                        [(ngModel)]="target.requiredCompaction"
                        name="requiredCompaction"
                    />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="optimumMoisture">Max Density and Optimum Moisture</label>
                    <input
                        type="text"
                        class="form-control"
                        id="optimumMoisture"
                        [(ngModel)]="target.optimumMoisture"
                        name="optimumMoisture"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="pitLocation">Pit Location</label>
                    <input type="text" class="form-control" id="pitLocation" [(ngModel)]="target.pitLocation" name="pitLocation" />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="proctorDate">Proctor Date</label>
                    <input type="date" class="form-control" id="proctorDate" [(ngModel)]="target.proctorDate" name="proctorDate" />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="dispatchContact">Dispatch Contact</label>
                    <input
                        type="text"
                        class="form-control"
                        id="dispatchContact"
                        [(ngModel)]="target.dispatchContact"
                        name="dispatchContact"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="testingCompanyVendorId">Testing Company</label>
                    <wj-combo-box
                        id="testingCompanyVendorId"
                        [(ngModel)]="target.testingCompanyVendorId"
                        name="testingCompanyVendorId"
                        [itemsSource]="testingCompanyOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isEditable]="false"
                        style="width: 100%"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="save()">Save</button>
    </div>
</form>
